module.exports = __webpack_public_path__ + "img/ResumeGood.104b98e9.svg";